import instance from "../../axios";

export const setCities = (data) => ({
  type: "SET_CITIES",
  payload: data,
});
export const setUserCities = (data) => ({
  type: "SET_USER_CITIES",
  payload: data,
});
export const clearCities = () => ({
  type: "CLEAR_CITIES",
});


export const fetchUserCities = (userId, translate) => {
  return async (dispatch) => {
    try {
      const response = await instance({
        url: `/api/citys/get`,
        method: "GET",
        params: {
          userId:userId?.id,
          limit: -1,
        },
      });

      const res = response?.data;
        const updateCities = res?.map((item) => ({
          ...item,
          name: item?.cityEn || item?.region,
          label: item?.cityEn || item?.region,
        }));

        dispatch(setUserCities(updateCities));

    } catch (error) {
      console.error("Fetch cities failed:", error);
    }
  };
};